module.exports = __webpack_public_path__ + "img/ontology-trait-disease.a5a1afb7.png";